import { AccessDeniedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  FinishTransfer,
  FinishTransferParams,
} from "../../domain/usecases/finish-transfer";

import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbFinishTransfer implements FinishTransfer {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async finish(params: FinishTransferParams): Promise<boolean> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        return res.body;
    }
  }
}
